import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../AuthContext";

export default function RequireRoles({ children, allowed = [] }) {
  const { token, roles, hasRole } = useContext(AuthContext);
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  if (allowed.length > 0) {
    const roleList = Array.isArray(roles) ? roles : roles ? [roles] : [];
    const hasRequired = allowed.some(
      (role) => (typeof hasRole === "function" && hasRole(role)) || roleList.includes(role),
    );
    if (!hasRequired) {
      return <Navigate to="/" replace />;
    }
  }
  return children;
}
